import React from 'react';

export default function FormSuccess() {
  return (
    <div
      id="gtm--successful-contact"
      className="contact-us--content__form-success"
    >
      <p className="contact-us--content__form-success--text">
        Your information has been sent.
      </p>
    </div>
  );
}
